import { createMultipleParam } from '@appscience/utils'
import { indexBy, prop } from 'ramda'
import { API_URL } from 'src/config/environment'
import { ShippedItem } from '../../../views/warehouse/from-warehouse/shipped/model/atoms'
import apiCreator from '../../api-creator'
import { Api_Item } from '../../common/item-model'
import {
  getItemInvoicePrice,
  handleErrorWithDefaultValue,
} from '../../common/utils'
import { parseDate } from '@app/utils/date'

interface Params {
  warehouseIds: Array<string>
  packageId?: string
}

export function getShippedItems({
  warehouseIds,
  packageId,
}: Params): Promise<Record<string, ShippedItem>> {
  if (packageId !== undefined) {
    return apiCreator
      .get(`${API_URL.TWIN}/get-package?id=${packageId}`)
      .then(res => {
        const rawData: Array<Api_Item> = res.data.items
        return indexBy(prop('id'), rawData.map(remapToShippedItem))
      })
      .catch(handleErrorWithDefaultValue({}))
  }
  return apiCreator
    .get(
      `${API_URL.TWIN}/items?step=in-package&${createMultipleParam(
        warehouseIds,
        'from_warehouse_id',
      )}&shipment_status=shipped`,
    )
    .then(res => {
      const rawData: Array<Api_Item> = res.data.items
      return indexBy(prop('id'), rawData.map(remapToShippedItem))
    })
    .catch(handleErrorWithDefaultValue({}))
}

export function remapToShippedItem(data: Api_Item): ShippedItem {
  return {
    id: data.id,
    airtableLink: data.airtable_link,
    amoId: data.deal_id,
    brand: data.brand,
    invoiceName: data.name,
    originalName: data.original_name,
    originCountry: data.country_of_origin,
    hsCodeSecondary: data.hs_code_secondary,
    store: data.store,
    grossWeight: data.gross_weight_kg,
    netWeight: data.net_weight_kg,
    lot: data.provider_lot,
    source_number: data.source_number,
    toHub0: parseDate(data.sent_to_hub_0 || '') || null,
    hub0: data.hub_0,
    trackHub0: data.track_to_hub_0,
    tswed: parseDate(data.registration_date || '') || null,
    catalogueId: data.catalogue_id,
    temperatureId: data.provider_temp,
    hazmat: data.provider_hazmat,
    quantity: data.quantity,
    packing: data.package_size,
    itemCost: data.cost,
    tax: data.tax,
    otherCost: data.other_cost,
    sumCost: data.full_cost,
    customPrice: data.custom_price_main,
    customPriceCurrency: data.custom_price_currency,
    invoicePrice: getItemInvoicePrice(data) || 0,
    currencyId: data.currency,
    invoiceNumber: data.package_invoice,
    toWarehouseId: data.to_warehouse_id,
    departureDate: parseDate(data.departure_date),
    transporterId: data.transporter,
    exportComment: data.provider_comment,
    exportStatuses: data.provider_export_statuses || [],
    boxNumber: data.box_numbers,
    procurement: data.procurement,
    responsibleSCD: data.responsible_scd,
    express: data.express ?? false,
    locations: data.provider_locations,
    prtComments: data.procurement_comment,
    providerTagToHub: data.provider_tag_to_hub,
    providerTagToTransit: data.provider_tag_to_transit,
    providerTagToRu: data.provider_tag_to_ru,
    sdExp: String(data.sd_exp || '').trim(),
  }
}
